export enum ServiceStatusType {
  Normal = 'normal',
  AtRisk = 'atRisk',
  Disruption = 'disruption',
  Cancelled = 'cancelled',
}
